import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ErrorModal({ onOpen, toggle, handleErrorDownload, title, successCount, errorCount, totalCount }) {
  const { t } = useTranslation('common');

  return (
    <Modal
      className="common-custom-modal modal-medium"
      aria-labelledby="contained-modal-title-vcenter"
      size="lg"
      show={onOpen}
      onHide={toggle}
      backdrop="static"
    >
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <span onClick={() => toggle()} className="icon-close" />
      </Modal.Header>
      <Modal.Body>
        <div className="modal-inner-data">
          <div className="checkbox-label">
            <span className="f-16 text-center font-medium">{t('BOM_LIBRARY.ERROR_MODAL.CONTAIN_VALIDATION_ERROR')} </span>
            {successCount > 0 && (
              <p className="f-16 mt-2 mb-0">
                {t('BOM_LIBRARY.ERROR_MODAL.RECORDS_IMPORTED')} {successCount} / {totalCount}
              </p>
            )}
            {errorCount > 0 && (
              <p className="f-16 mt-2 mb-0">
                {t('BOM_LIBRARY.ERROR_MODAL.RECORD_NOT_IMPORTED')} {errorCount} / {totalCount}
              </p>
            )}
          </div>
        </div>
        <div className="common-model-footer">
          <button aria-label="download" title={t('BOM_LIBRARY.ERROR_MODAL.DOWNLOAD')} className="btn p-0" type="button" onClick={() => handleErrorDownload()}>
            <i className="icon-Tick-1 f-24" />
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ErrorModal;
